import { createApp } from 'vue'
import App from './App.vue'
import "./style/index.sass"
import "./style/content.sass"
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router'
import 'animate.css';
import { vAnimate } from './utils/animate'



const app = createApp(App)


app.use(router)
app.mixin({ // 全局混入，为所有组件添加$navigateTo方法
    methods: {
        $navigateTo(path) {
            this.$router.push(path); // 使用Vue Router的push方法进行跳转
        }
    }
});
app.use(ElementPlus)
    // 全局注册指令
app.directive('animate', vAnimate)
app.mount('#app')